import $ from 'jquery';
import { MIN_DELAY } from '../variables/variables.js';
import Swiper from 'swiper/swiper-bundle.min';



$( () => {
	if ( ! $( '.about' ).length ) {
		return;
	}

	// История
	( () => {
		const $years = $( '.about__history-year' );

		new Swiper( '.about__history-description .swiper', {
			slidesPerView: 'auto',
			effect:        'fade',
			navigation: {
				nextEl: '.about__history-arrows .swiper-button-next',
				prevEl: '.about__history-arrows .swiper-button-prev',
			},
			pagination: {
				el:        '.about__history-pagintaion',
				clickable: true,
			  },
		} );

		$( '.about__history-pagintaion .swiper-pagination-bullet' ).each( function( i ) {
			this.innerText = $years[ i ].innerText;
		} );
	} )();

	// Показать всю команду
	$( '.about__team-button' ).on( 'click', function() {
		const $units = $( '.about__team-unit' );

		$units.addClass( 'about__team-unit_active' );
		setTimeout( () => {
			$units.addClass( 'about__team-unit_animate' );
			$( this ).addClass( 'hidden' );
		}, MIN_DELAY );
	} );
} );
